import styled from "styled-components"

export const CommentItemWrapper = styled.div`

.comment_ask{
        &_top{
            &_login{
                display: block;
                background-color: #469ef4;
                width: 200px;
                height: 35px;
                border: none;
                outline: none;
                color: #fff;
                font-size: 0.9rem;
                border-radius: 4px;
                &:hover{
                    background-color: rgb(106, 39, 174);
                }
                margin-bottom: 12px;
            }
            padding-bottom: 12px;
            &_form{
                textarea{
                    height: 100px;
                    max-height: 100px;
                    width: 100%;
                    padding: 8px;
                    font-size: 1.0rem;
                    color: #000000;
                    outline: none;
                    border: none;
                    border-bottom: 1px solid #e2c1c1;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }
                border: 1px solid #e2c1c1;
                border-radius: 4px;
                div{
                    display: flex;
                    justify-content: space-between;
                    height: 100%;
                    padding: 0 12px 8px 12px;
                    button{
                        position: relative;
                        float: right;
                        height: 30px;
                        width: 150px;
                        outline: none;
                        border:  none;
                        background-color: #2f80ed;
                        color: #fff;
                        border-radius: 4px;
                        &:hover{
                            background-color: rgb(106, 39, 174);
                        }
                    }
                    p{
                        font-style: italic;
                        color: #ff6801;
                        font-size: 0.9rem;
                        padding: 0;
                        margin: 0;
                    }
                }
                margin-bottom: 12px;
            }
            &_totalcomment{
                color: #000000;
                font-weight: bold;
            }
            &_filter{
                margin-top: 12px;
                label{
                    margin-right: 12px;
                    font-size: 0.9rem;
                    color: #626060;
                }
                select{
                    font-size: 0.9rem;
                    color: #626060;
                    cursor: pointer;
                    padding: 4px;
                    outline: none;
                }
            }
        }
        &_list{
            list-style: none;
            margin: 12px 0;
            padding: 0;
            &_item{
                margin-top: 12px;
                padding-top: 12px;
                border-top: 1px solid #e2c1c1;
                border-left: 4px solid #e2c1c1;
                padding-left: 12px;
                &_show, &_hide{
                    display: flex;
                    cursor: pointer;
                    font-size: 0.9rem;
                    border-top: 1px solid #e2c1c1;
                    padding-top: 8px;
                    width: 100%;
                    justify-content: start;
                    align-items: center;
                    &:hover{
                        color: rgb(106, 39, 174);
                    }
                    color: #2f80ed;
                    
                }
                &_show{
                    i{
                        margin-left: 8px;
                        margin-bottom: 6px;
                    }
                }
                &_hide{
                    i{
                        margin-left: 8px;
                        margin-top: 6px;
                    }
                }
            }
        }
        &_bottom{
            margin-top: 26px;
            display: flex;
            justify-content: center;
            a{
                height: 30px;
                width: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                &:nth-child(1){
                    background-color: #2f80ed;
                    color: #fff;
                    border-radius: 4px;
                    &:hover{
                        background-color: #fff;
                        color: #2f80ed;
                        border:  1px solid #2f80ed;
                    }
                }
                &:nth-child(2){
                    color: #fff;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border:  1px solid #2f80ed;
                    color: #2f80ed;
                    &:hover{
                        background-color: #2f80ed;
                        color: #fff;
                    }
                }
            }
        }
    }

.comment_pagination {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 22px 0 12px 0;
    padding: 12px 0;
    border-top: 1px solid #e2c1c1;
}

`